import React from 'react'
import Button from './components/button'
import './page-login.scss'


export default function LoginPage() {
    const [token, setToken] = React.useState('')
    const [user, setUser] = React.useState('')

    return <div className="page-login">
        <div className="page-login__inner">
            <input
                className="token-input"
                placeholder="User..."
                type="text"
                value={user}
                autoFocus
                onChange={e => setUser(e.target.value)}
                autoFocus
            />
            <input
                className="token-input"
                placeholder="Token..."
                type="password"
                value={token}
                autoFocus
                onChange={e => setToken(e.target.value)}
            />
            <Button
                onClick={() => {
                    localStorage.setItem('wrkt-token', token)
                    localStorage.setItem('wrkt-user', user)
                    window.location.hash = ''
                    window.location.reload()
                }}
            >
                Login
            </Button>
        </div>
    </div>
}
